import Repository from './Repository'

const resource = 'off-days'

export default {
  getOffDays (tenantId, params) {
    return Repository.get(`tenants/${tenantId}/${resource}`, { params: params })
  },
  createOffDays (tenantId, data) {
    return Repository.post(`tenants/${tenantId}/${resource}`, data)
  },
  updateOffDays (tenantId, offDayId, data) {
    return Repository.patch(`tenants/${tenantId}/${resource}/${offDayId}`, data)
  },
  deleteOffDays (tenantId, offDayId) {
    return Repository.delete(`tenants/${tenantId}/${resource}/${offDayId}`)
  }
}
